import en from './en.json';
import fr from './fr.json';

export const performanceReportsI18n = {
  fr,
  en,
};
